<template>
  <swiper-slide class="swiper_newpage1">
  </swiper-slide>
</template>
  <script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.min.css";
export default {
  name: "newpage1",
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
    };
  },
};
</script>
  <style lang="less" scoped>
.swiper_newpage1{
    width: 100% !important;
  height: 100%;
  background: url("../assets/newpagebg1.jpg") no-repeat;
  background-size: 100% 100%;
}
</style>